import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center" }
const _hoisted_2 = { class: "dropdown" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomSearch = _resolveComponent("CustomSearch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "btn btn-light-primary",
        type: "button",
        id: "dropdownMenuButton",
        "data-toggle": "dropdown",
        "aria-haspopup": "true",
        "aria-expanded": "false",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showDropDownMenu()))
      }, _cache[1] || (_cache[1] = [
        _createTextVNode(" Filtro ", -1),
        _createElementVNode("i", { class: "bi bi-funnel-fill" }, null, -1)
      ])),
      _createElementVNode("div", {
        class: _normalizeClass(["dropdown-menu dropdown-menu-right", _ctx.data.show_drop_down_menu ? 'show-element' : 'not-show-element']),
        "aria-labelledby": "dropdownMenuButton",
        "aria-haspopup": "true",
        "aria-expanded": "false",
        style: {"z-index":"100 !important"}
      }, [
        _createVNode(_component_CustomSearch, {
          fields: _ctx.fields,
          onAplicar: _ctx.getFilledData,
          title: 'Opções de Filtro',
          onClose: _ctx.hideDropDownMenu,
          onSelected: _ctx.getSelectedData,
          onCanceled: _ctx.getCanceled,
          onCleaned: _ctx.getCleaned
        }, null, 8, ["fields", "onAplicar", "onClose", "onSelected", "onCanceled", "onCleaned"])
      ], 2)
    ])
  ]))
}